<template>
  <div class="c-checkbox__container">
    <label class="c-checkbox__label">
      <input
        type="checkbox"
        class="c-checkbox"
        :id="'checkbox' + type"
        :required="isRequired ? true : false"
        v-model="checked"
        @change="change"
      />
      <span class="c-checkbox__visual"></span>
      <span class="c-checkbox__text">{{ text }}</span>
    </label>
  </div>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'Checkbox',
  data() {
    return {
      text: this.dataText ? this.dataText : '',
      type: this.dataType ? this.dataType : '',
      isRequired: this.dataIsRequired ? this.dataIsRequired : false,
      checked: this.dataChecked || false
    };
  },
  props: {
    dataText: String,
    dataType: String,
    dataIsRequired: Boolean,
    dataChecked: Boolean
  },
  methods: {
    change() {
      this.$emit('childToParent', this.checked);
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
$itemHeight: 2.2rem;
$lineHeight: 1.2rem;
$padding: ($itemHeight - $lineHeight) / 2;

@import '@/assets/scss/components/checkbox.scss';
</style>
